import { createFileRoute } from "@tanstack/react-router";
import { BulkDealUpload } from "@/components/Deals/BulkUpload";

function RouteComponent() {
  return <BulkDealUpload />;
}

export const Route = createFileRoute("/_authenticated/deals/bulk-upload/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
